import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgTreatmentPlanIconSecondary(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M12.74 0H3.2C2.54 0 2 .54 2 1.2v13.6c0 .66.54 1.2 1.2 1.2h9.54c.66 0 1.2-.54 1.2-1.2V1.2c0-.66-.54-1.2-1.2-1.2Zm-.3 14.5H3.5v-13h8.94v13Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M5.22 11.15h5.5a.749.749 0 1 0 0-1.5h-5.5a.749.749 0 1 0 0 1.5ZM5.22 13.56h2.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.5a.749.749 0 1 0 0 1.5ZM5.43 6.46h1.79v1.79a.749.749 0 1 0 1.5 0V6.46h1.79a.749.749 0 1 0 0-1.5H8.72v-1.8c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.79H5.43a.755.755 0 0 0 0 1.51Z",
    fill: "currentColor"
  }));
}

export { SvgTreatmentPlanIconSecondary as default };
